import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiVisa, BasicApiResponseModel, BaseApiTemplateService} from '../../shared';
import {Core2Config} from '../../shared';
import { ClaimCycleReviewSettingContainerModel} from '../../../../../../models';


@Injectable({
  providedIn: 'root'
})
export class ClaimCycleReviewSettingService extends BaseApiTemplateService<ClaimCycleReviewSettingContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
    Core2Config.CLAIMS_PREFIX + 'cycles/review-settings/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycles/review-settings/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycles/review-settings/backoffice-ep';
    this.httpClient = http;
  }

  public getDistinctApprovalLevelValues(visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
    Core2Config.CLAIMS_PREFIX + 'cycles/review-settings/public/distinct-approval-level/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
    Core2Config.CLAIMS_PREFIX + 'cycles/review-settings/public/distinct-approval-level/backoffice-ep';
    }
    return this.httpClient.get<BasicApiResponseModel<Number[]>>(url, this.getHttpHeader(visa));
  }

}


